import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PhysicianApi } from '../api/physician-mst.api';
import { switchMap, map } from 'rxjs/operators';

import { PhysicianData, Physician } from '../../../interfaces/masters/physician-mst';

@Injectable()
export class PhysicianMstService extends PhysicianData {

    constructor(private api: PhysicianApi) {
      super();
    }
  
  
    list(url: string): Observable<Physician[]> {
      return this.api.list(url);
    }
  newlist(url: string): Observable<Physician[]> {
      return this.api.list(url);
    }
    getById(url:string): Observable<Physician>{
        return this.api.getById(url);
    }
  
    create(url: string, data:Physician): Observable<Physician[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:Physician): Observable<Physician> {
      return this.api.update(url,data);
    }

    getPhysicianSetting(url:string): Observable<any>{
      return this.api.getPhysicianSetting(url);
  }

  createPhysicianSettings(url: string, data:any): Observable<any[]> {
    return this.api.addPhysicianSetting(url,data);
  }
  saveMPOMaster(url: string, data:any): Observable<any> {
    return this.api.saveMPOMaster(url,data);
  }

  updatePhysicianSettings(url: string, data:any): Observable<any> {
    return this.api.updatePhysicianSetting(url,data);
  }

  getFilterList(url,params): Observable<any> {
    return this.api.getFilterList(url,params)
  }

    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
    searchList(url: string,data:any): Observable<any> {
      return this.api.searchList(url,data);
    }
  }
  